import { Loading } from "components/shared";
import React, { useEffect } from "react";
import useMagicAction, { ITEMS_SCHEMA, asItems } from "./useMagicAction";


const SuggestHashtags = (props) => {

    const { run, input, writeBackInsert, closeMenu } = useMagicAction(props);

    useEffect(() => {
        run({
            prompt: `Suggest 3 trending hashtags relevant to the following text. Do not repeat hashtags already present in it.\n\nTEXT:\n${input}`,
            schema: ITEMS_SCHEMA("A hashtag, including the # symbol"),
        })
            .then((r) => {
                const text = asItems(r)
                    .map((h) => (h.startsWith("#") ? h : `#${h.replace(/^#+/, "")}`))
                    .join(" ");
                if (text) writeBackInsert(` ${text}`);
            })
            .finally(closeMenu);
    }, []);

    return (
        <div className="flex flex-col items-center justify-center gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default SuggestHashtags;
